/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { CreateElectronBeamQualitiesDto } from './CreateElectronBeamQualitiesDto';
import {
    CreateElectronBeamQualitiesDtoFromJSON,
    CreateElectronBeamQualitiesDtoFromJSONTyped,
    CreateElectronBeamQualitiesDtoToJSON,
} from './CreateElectronBeamQualitiesDto';
import type { CreateLinearAcceleratorDtoSourceAxisDistance } from './CreateLinearAcceleratorDtoSourceAxisDistance';
import {
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON,
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSONTyped,
    CreateLinearAcceleratorDtoSourceAxisDistanceToJSON,
} from './CreateLinearAcceleratorDtoSourceAxisDistance';
import type { CreatePhotonBeamQualitiesDto } from './CreatePhotonBeamQualitiesDto';
import {
    CreatePhotonBeamQualitiesDtoFromJSON,
    CreatePhotonBeamQualitiesDtoFromJSONTyped,
    CreatePhotonBeamQualitiesDtoToJSON,
} from './CreatePhotonBeamQualitiesDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { NullableOneOfPropertyOfStorageLocation } from './NullableOneOfPropertyOfStorageLocation';
import {
    NullableOneOfPropertyOfStorageLocationFromJSON,
    NullableOneOfPropertyOfStorageLocationFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationToJSON,
} from './NullableOneOfPropertyOfStorageLocation';
import type { OneOfPropertyOfPtw100InternalArea } from './OneOfPropertyOfPtw100InternalArea';
import {
    OneOfPropertyOfPtw100InternalAreaFromJSON,
    OneOfPropertyOfPtw100InternalAreaFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaToJSON,
} from './OneOfPropertyOfPtw100InternalArea';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface CreateLinearAcceleratorDto
 */
export interface CreateLinearAcceleratorDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateLinearAcceleratorDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateLinearAcceleratorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLinearAcceleratorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLinearAcceleratorDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateLinearAcceleratorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateLinearAcceleratorDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof CreateLinearAcceleratorDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof CreateLinearAcceleratorDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {CreateElectronBeamQualitiesDto}
     * @memberof CreateLinearAcceleratorDto
     */
    beamQualitiesElectron?: CreateElectronBeamQualitiesDto;
    /**
     * 
     * @type {CreatePhotonBeamQualitiesDto}
     * @memberof CreateLinearAcceleratorDto
     */
    beamQualitiesPhoton?: CreatePhotonBeamQualitiesDto;
    /**
     * 
     * @type {CreateLinearAcceleratorDtoSourceAxisDistance}
     * @memberof CreateLinearAcceleratorDto
     */
    sourceAxisDistance?: CreateLinearAcceleratorDtoSourceAxisDistance | null;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof CreateLinearAcceleratorDto
     */
    parentCoordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {NullableOneOfPropertyOfStorageLocation}
     * @memberof CreateLinearAcceleratorDto
     */
    imageLocation?: NullableOneOfPropertyOfStorageLocation;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {OneOfPropertyOfPtw100InternalArea}
     * @memberof CreateLinearAcceleratorDto
     */
    ptw100AreaName?: OneOfPropertyOfPtw100InternalArea;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    $type?: CreateLinearAcceleratorDtoTypeEnum;
}


/**
 * @export
 */
export const CreateLinearAcceleratorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateLinearAcceleratorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateLinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateLinearAcceleratorDtoTypeEnum = typeof CreateLinearAcceleratorDtoTypeEnum[keyof typeof CreateLinearAcceleratorDtoTypeEnum];


/**
 * Check if a given object implements the CreateLinearAcceleratorDto interface.
 */
export function instanceOfCreateLinearAcceleratorDto(value?: unknown): value is CreateLinearAcceleratorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateLinearAcceleratorDtoTypeEnum)[0];
}

export function CreateLinearAcceleratorDtoFromJSON(json: any): CreateLinearAcceleratorDto {
    return CreateLinearAcceleratorDtoFromJSONTyped(json, false);
}

export function CreateLinearAcceleratorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLinearAcceleratorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'beamLimitingDeviceType': !exists(json, 'beamLimitingDeviceType') ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': !exists(json, 'beamProduction') ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'beamQualitiesElectron': !exists(json, 'beamQualitiesElectron') ? undefined : CreateElectronBeamQualitiesDtoFromJSON(json['beamQualitiesElectron']),
        'beamQualitiesPhoton': !exists(json, 'beamQualitiesPhoton') ? undefined : CreatePhotonBeamQualitiesDtoFromJSON(json['beamQualitiesPhoton']),
        'sourceAxisDistance': !exists(json, 'sourceAxisDistance') ? undefined : CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON(json['sourceAxisDistance']),
        'parentCoordinateSystem': !exists(json, 'parentCoordinateSystem') ? undefined : CoordinateSystemFromJSON(json['parentCoordinateSystem']),
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'imageLocation': !exists(json, 'imageLocation') ? undefined : NullableOneOfPropertyOfStorageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': !exists(json, 'externalRtSystemId') ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': !exists(json, 'externalFileSystemPath') ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': !exists(json, 'ptw100AreaName') ? undefined : OneOfPropertyOfPtw100InternalAreaFromJSON(json['ptw100AreaName']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateLinearAcceleratorDtoToJSON(value?: CreateLinearAcceleratorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isAvailable': value.isAvailable,
        'isArchived': value.isArchived,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value.typeSpecification,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value.beamLimitingDeviceType),
        'beamProduction': MedicalSystemBeamProductionToJSON(value.beamProduction),
        'beamQualitiesElectron': CreateElectronBeamQualitiesDtoToJSON(value.beamQualitiesElectron),
        'beamQualitiesPhoton': CreatePhotonBeamQualitiesDtoToJSON(value.beamQualitiesPhoton),
        'sourceAxisDistance': CreateLinearAcceleratorDtoSourceAxisDistanceToJSON(value.sourceAxisDistance),
        'parentCoordinateSystem': CoordinateSystemToJSON(value.parentCoordinateSystem),
        'serialNumber': value.serialNumber,
        'imageLocation': NullableOneOfPropertyOfStorageLocationToJSON(value.imageLocation),
        'externalRtSystemId': value.externalRtSystemId,
        'externalFileSystemPath': value.externalFileSystemPath,
        'ptw100AreaName': OneOfPropertyOfPtw100InternalAreaToJSON(value.ptw100AreaName),
        '$type': value.$type,
    });
}

